<template>
  <div id="NewsNews">
    <h1>{{$t("newAlert.new")}}</h1>
    <div class="form-container">
      <!-- Users -->
      <div class="input-container recipients">
        <label for="alertPriority">{{$t("newAlert.users")}}</label>
        <router-link
          :to="{
          name: 'User Search',
          params: {
            type: this.alertType,
            priority: this.alertPriority,
            controlNumbers: this.recipients,
            title: this.alertTitle,
            subtitle: this.alertSubtitle,
            cover: this.imageResp,
            body: this.alertBody,
            media: this.media
          },
          query: {
            path: $route.name,
            id: this.id
          }
        }"
        >{{$t('newAlert.users_select')}} ></router-link>
        <p v-if="recipients">{{recipients.length}} {{$t('newAlert.users_selected')}}</p>
        <p v-else>{{$t('newAlert.users_all')}}</p>
      </div>
      <!-- Alert type -->
      <div class="input-container">
        <label for="alertType">{{$t("newAlert.alertType")}}</label>
        <select id="alertType" name="alertType" v-model="$v.alertType.$model">
          <option disabled :value="null">{{$t("newAlert.alertTypePH")}}</option>
          <option value="notice">{{$t("newAlert.notice")}}</option>
          <option value="alert">{{$t("newAlert.alert")}}</option>
        </select>
        <div class="error-msg">
          <span v-if="$v.alertType.$error">{{$t("newAlert.errors.type")}}</span>
        </div>
      </div>
      <!-- Alert priority -->
      <div class="input-container" v-if="alertType == 'alert'">
        <label for="alertPriority">{{$t("newAlert.alertPriority")}}</label>
        <select id="alertPriority" name="alertPriority" v-model="$v.alertPriority.$model">
          <option disabled :value="null">{{$t("newAlert.alertPriorityPH")}}</option>
          <option value="low">{{$t("newAlert.yellowAlert")}}</option>
          <option value="medium">{{$t("newAlert.orangeAlert")}}</option>
          <option value="high">{{$t("newAlert.redAlert")}}</option>
        </select>
        <div class="error-msg">
          <span v-if="$v.alertPriority.$error">{{$t("newAlert.errors.priority")}}</span>
        </div>
      </div>
      <!-- Date & Time -->
      <!-- <div class="datetime-container">
        <div class="checkDateTime">
          <input type="checkbox" id="dateTime" v-model="alertDateTime">
          <label for="dateTime">{{$t("newAlert.datetime")}}</label>
        </div>
        <div class="date">
          <label>{{$t("newAlert.date")}}</label>
          <input
          id="date"
          type="date"
          v-model="alertDate"
          :disabled="!alertDateTime">
        </div>
        <div class="time">
          <label for="time">{{$t("newAlert.time")}}</label>
          <input
          id="hour"
          name="hour"
          type="number"
          min="0"
          max="23"
          v-model.number="hours"
          :disabled="!alertDateTime">
          &nbsp;:&nbsp;
          <input
          id="minute"
          name="minute"
          type="number"
          min="0"
          max="59"
          v-model.number="minutes"
          :disabled="!alertDateTime">
        </div>
        <div class="error-msg">
          <span v-if="$v.dateTime.$error">{{$t("newAlert.errors.dateTime")}}</span>
        </div>
      </div>-->
      <!-- Alert title -->
      <div class="input-container">
        <label for="title">{{$t("newAlert.alertTitle")}}</label>
        <input
          type="text"
          id="title"
          name="title"
          :placeholder="$t('newAlert.alertTitlePH')"
          v-model="$v.alertTitle.$model"
        />
        <div class="error-msg">
          <span v-if="$v.alertTitle.$error">{{$t("newAlert.errors.title")}}</span>
        </div>
      </div>
      <!-- Alert subtitle -->
      <div class="input-container">
        <label for="subtitle">{{$t("newAlert.alertSubtitle")}}</label>
        <input
          type="text"
          id="subtitle"
          name="subtitle"
          :placeholder="$t('newAlert.alertSubtitlePH')"
          v-model="alertSubtitle"
        />
        <div class="error-msg">
          <span v-if="$v.alertSubtitle.$error">{{$t("newAlert.errors.subtitle")}}</span>
        </div>
      </div>
      <!-- File input - img -->
      <div class="input-container">
        <label>{{$t("newAlert.alertImage")}}</label>
        <FileUploader
          v-if="!alertLoading"
          :placeholder="$t('newAlert.alertImagePH')"
          :type="'image/*'"
          :validate="'image/'"
          :label="$t('newAlert.browse')"
          :fileUrl="alertImgUrl"
          @setFile="setFile"
        />
      </div>

      <!-- new componet to support audio & video files -->
      <MediaInput
        :media="media"
        :key="mediaInputKey"
        @onChangeMedia="onChangeMedia"
      />

      <!-- Wysiwyg -->
      <div class="input-container">
        <label>{{$t("newAlert.alertBody")}}</label>
        <div class="wysiwyg">
          <Wysiwyg
            v-if="!alertLoading"
            :placeholder="$t('newAlert.alertBodyPH')"
            :articleBody="alertDelta"
            :includeMediaContent="false"
            v-on:updateBody="alertBody = $event;"
          ></Wysiwyg>
        </div>
        <div class="error-msg">
          <span v-if="$v.alertBody.$error || displayContentError">{{$t("newAlert.errors.body")}}</span>
        </div>
      </div>
      <!-- Cancel / Publish controllers -->
      <div class="input-container controllers">
        <div class="error-msg">
          <span v-if="serverError">{{$t("newAlert.errors.server")}}</span>
        </div>
        <span class="control cancel-btn" @click="cancelPublish">{{$t('newAlert.cancel')}}</span>
        <button
          type="button"
          class="btn btn-dark control publish-btn"
          :disabled="isLoading"
          @click="validateForm"
        >{{$t('newAlert.publish')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import MediaInput from '@/components/mediaInput/MediaInput';
import Notif from "@/lib/api/Notification.js";
import S3_Handler from "@/lib/api/s3_handler";
import { required, requiredIf } from "vuelidate/lib/validators";
import {
  mediaTypes,
  media,
  mediaPath,
  mediaPosition,
  mediaContentType,
  hasContent,
  isValidBody
} from "@/lib/constants.js";

const FileUploader = () => import("@/components/FileUploader");
const Wysiwyg = () => import("@/components/Wysiwyg");

export default {
  components: {
    FileUploader,
    Wysiwyg,
    MediaInput
  },
  props: {
    id: {
      required: false
    },
    type: {
      required: false
    },
    selected: {
      required: false
    }
  },
  data: function() {
    return {
      alertLoading: true,
      isLoading: false,
      serverError: false,
      alertType: this.type || null,
      alertPriority: null,
      // alertDateTime: false,
      // alertDate: null,S
      alertTitle: null,
      alertSubtitle: null,
      alertImgUrl: null,
      alertImage: null,
      alertDelta: {
        ops: []
      },
      alertBody: null,
      imageResp: "",
      media: {
        audio: { key: '', url: '' },
        video: { key: '', url: '' },
        location: ''
      },
      mediaInputKey: new Date().getTime(),
      hasAudio: false,
      hasVideo: false,
      displayContentError: false
      // hours: 0,
      // minutes: 0
    };
  },
  computed: {
    recipients: function() {
      return this.$store.getters["users/recipients"];
    },
    mediaAudio () {
      return this.media.audio;
    },
    mediaVideo () {
      return this.media.video;
    },
    // computed: {
    // selectedVal: {
    //   get() {
    //     return this.value
    //   },
    //   set(val) {
    //     //this.value = val
    //     this.$emit('input', val)
    //   }
    // }
  },
    //   getDateTime: function() {
    //     const dateTime = `${this.alertDate} ${this.hours}:${this.minutes}`;
    //     if (moment(dateTime, 'YYYY-MM-DD H:m').isValid()){
    //       return moment(dateTime, 'YYYY-MM-DD H:m').format();
    //     } else {
    //       return null;
    //     }
    //   }
 
  watch: {
    alertType: function(newValue) {
      if (newValue != "alert") {
        this.alertPriority = null;
        this.$v.alertPriority.$reset();
      }
    },
    // alertDateTime: function(newValue) {
    //   if (!newValue) {
    //     this.day = null;
    //     this.month = null;
    //     this.year = null;
    //     this.hours = null;
    //     this.minutes = null;
    //   }
    // }
  },
  validations: {
    alertType: {
      required
    },
    alertTitle: {
      required
    },
    alertSubtitle: {
      required
    },
    alertBody: {
      required: requiredIf(function() {
        if (this.hasAudio || this.hasVideo) {
          return false;
        } else {
          return true;
        }
      })
    },
    alertPriority: {
      isRequired: function() {
        if (this.alertType == "alert") {
          if (this.alertPriority) {
            return true;
          }
          return false;
        }
        return true;
      }
    }
    // dateTime: {
    //   isRequired: function() {
    //     if (this.alertDateTime) {
    //       if (this.getDateTime) {
    //         return true;
    //       }
    //       return false;
    //     }
    //     return true;
    //   }
    // }
  },
  beforeMount: async function() {
    const emptyMedia = { key: '', url: '' };
    this.media.audio = emptyMedia;
    this.media.video = emptyMedia;

    if (this.id) {
      try {
        await this.getAlert();
        if (this.$route.params.title) {
          await this.fill();
        }
      } catch (error) {
        throw error;
      }
    } else {
      this.alertLoading = false;
      this.fill();
    }
  },
  methods: {
    getAlert: async function() {
      this.$store.commit("global/SET_LOADING", true);
      const service = new Notif();
      try {
        const response = await service.getNotification(this.id);
        this.alertType = response.type;
        this.alertPriority = response.priority;
        this.alertTitle = response.title;
        this.alertSubtitle = response.subtitle;
        this.alertImgUrl = response.cover;
        this.alertDelta = response.body;
        this.alertBody = response.body;
        this.alertLoading = false;

        this.media = response.media ? response.media : media;
        this.mediaInputKey = new Date().getTime();
        this.hasAudio = hasContent(this.media.audio);
        this.hasVideo = hasContent(this.media.video);

        if (!this.selected) {
          if (response.controlNumbers !== "*")
            this.$store.commit("users/SET_USERS", response.controlNumbers);
        }
        this.$store.commit("global/SET_LOADING", false);
      } catch (error) {
        this.alertLoading = false;
        this.$store.commit("global/SET_LOADING", false);
        throw error;
      }
    },
    setFile: function(file) {
      this.alertImage = file;
    },
    cancelPublish: function() {
      this.$store.commit("users/SET_USERS", null);
      this.$router.push({
        name: "News List"
      });
    },
    validateForm: function() {    
      this.displayContentError = false;
      this.$v.$touch();

      if(!this.hasAudio && !this.hasVideo && !isValidBody(this.alertBody)) {
        this.displayContentError = true;
        return;
      }

      if (this.$v.$error) {
        return;
      }
      try {
        this.postAlert();
      } catch (error) {
        throw error;
      }
    },
    postAlert: async function() {
      this.serverError = false;
      this.isLoading = true;
      this.$store.commit("global/SET_LOADING", true);
      const service = new Notif();
      try {
        const timestamp = Date.now();
        this.imageResp = await this.uploadImage(timestamp);

        const body = isValidBody(this.alertBody) ? this.alertBody : {ops: [{insert: '\n'}]};

        await this.uploadMedia();

        const alert = {
          type: this.alertType,
          priority: this.alertPriority,
          controlNumbers: this.recipients,
          // customDate: this.getDateTime,
          title: this.alertTitle,
          subtitle: this.alertSubtitle,
          cover: this.imageResp,
          body: body,
          author: this.$store.getters["session/author"],
          media: this.media
        };

        if (this.$route.name == "News Edit") {
          await service.updateNotif(alert, this.id);
        } else {
          await service.postNotif(alert);
        }

        this.isLoading = false;
        this.$store.commit("global/SET_LOADING", false);
        this.$router.push({
          name: "News List"
        });
      } catch (error) {
        if (error.data.statusCode === 502 || error.data.statusCode === 504) {
          this.$router.push({
            name: "News List"
          });
          return;
        }
        this.serverError = true;
        this.isLoading = false;
        this.$store.commit("global/SET_LOADING", false);
        throw error;
      }
    },
    uploadImage: async function(timestamp) {
      let s3 = new S3_Handler();
      try {
        if (this.alertImage) {
          const response = await s3.uploadFile(
            `${timestamp}.${this.alertImage.name.split(".").pop()}`,
            this.alertImage
          );
          return response.Location;
        } else {
          if (this.alertImgUrl) {
            return this.alertImgUrl;
          }
          return null;
        }
      } catch (error) {
        throw error;
      }
    },
    fill: async function() {
      try {
        const routeParams = this.$route.params;
        console.log(routeParams);
        if (routeParams && Object.keys(routeParams).length) {
          this.alertType = routeParams.type ? routeParams.type : this.alertType;
          this.alertPriority = routeParams.priority ? routeParams.priority : this.alertPriority;
          this.recipients = routeParams.controlNumbers ? routeParams.controlNumbers : this.recipients;
          this.alertTitle = routeParams.title ? routeParams.title : this.alertTitle;
          this.alertSubtitle = routeParams.subtitle ? routeParams.subtitle : this.alertSubtitle;
          const bodyParams = routeParams.body;
          this.alertDelta = bodyParams && bodyParams.ops && bodyParams.ops.length ? bodyParams : this.alertDelta;
          this.media = routeParams.media ? routeParams.media : this.media;
        }
      } catch (error) {
        throw error;
      }
    },
    uploadMedia: async function() {
      const audio = this.media.audio;
      const video = this.media.video;
     
      const fileName = `${this.alertType}-${Date.now()}`;

      try {
        if (audio.file) {
          const audioPath = `${mediaPath.audio}/${fileName}.${audio.file.name.split(".").pop()}`;
          const audioResponse = await this.uploadMediaToS3(audioPath, audio.file, mediaContentType.audio);
          if (audioResponse && audioResponse.Key) {
              this.media.audio = { key: audioResponse.Key };
          }
          delete this.media.audio.file;
        }

        if (video.file) {
          const videoPath = `${mediaPath.video}/${fileName}.${video.file.name.split(".").pop()}`;
          const videoResponse = await this.uploadMediaToS3(videoPath, video.file, mediaContentType.video);
          if (videoResponse && videoResponse.Key) {
              this.media.video = { key: videoResponse.Key };
          }
          delete this.media.video.file;
        }
        
        this.media.location = this.media.location ? this.media.location : mediaPosition.top;
        
      } catch (error) {
        this.$store.commit("global/SET_ALERT", {
          msg: this.$t('components.mediaInput.errors.uploadToS3'),
          show: true,
          type: "error"
        });
        console.error(error);
        throw error;
      }
      
    },
    uploadMediaToS3: async function (fileName, file, contentType) {
      const s3 = new S3_Handler();
      const response = await s3.uploadMediaFile(fileName, file, contentType);
      return response;
    },
    onChangeMedia: function (data) {
      const media = data.data;

     switch (data.type) {
        case mediaTypes.audio:
          this.hasAudio = Boolean(media);
          this.displayContentError = false;
          this.media.audio = {
              url: '',
              key: '',
              file: media
          }
          if(media) this.$v.alertBody.$reset();
        break;
        case mediaTypes.video:
          this.hasVideo = Boolean(media);
          this.displayContentError = false;
          this.media.video = {
              url: '',
              key: '',
              file: media
          }
          if(media) this.$v.alertBody.$reset();
        break;
        case mediaPosition.key:
          this.media.location = media.top ? mediaPosition.top : mediaPosition.bottom;
        break;        
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.form-container {
  width: 90%;

  @media (min-width: 769px) {
    width: 65%;
  }
  @media (min-width: 1216px) {
    width: 55%;
  }
  @media (min-width: 1408px) {
    width: 45%;
  }
}
  #NewsNews {
  background-color: $white;
  padding: 1rem 1rem;

}
.input-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 18px;
  margin: 20px 0px;

  label {
    @extend %audi-b;
  }
}
.recipients p {
  margin: 0;
}
.datetime-container {
  margin: 50px 0;

  .checkDateTime {
    font-size: 18px;
    display: flex;
    align-items: center;
    label {
      @extend %audi-b;
      margin-bottom: 0;
      margin-left: 10px;
    }
  }
  .date {
    margin: 10px 0;
    font-size: 18px;
    display: flex;
    align-items: center;
    label {
      @extend %audi-b;
      margin-bottom: 0;
      margin-right: 10px;
    }
  }
  .time {
    margin: 10px 0;
    font-size: 18px;
    display: flex;
    align-items: center;
    label {
      @extend %audi-b;
      margin-bottom: 0;
      margin-right: 10px;
    }
    #hour,
    #minute {
      width: auto;
      text-align: center;
    }
  }
}
.wysiwyg {
  width: 100%;
}
.controllers {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.controllers .control {
  margin-left: 15px;
  font-size: 16px;
  cursor: pointer;
}
.publish-btn {
  @extend %audi-b;
  color: $white;
  background-color: $black;
  padding: 10px 20px;
  border-radius: 0px;
}
.error-msg {
  color: $warn_red;
  font-size: 14px;
}
</style>